import React, { ReactElement, useEffect, useState } from 'react';
import './KodanshaNewsWheelItem.scss';
import { Link } from '../../Devon/Components/InkyLink';
import { convertDate } from '../../utils/utils';

import NewPlaceHolder from '../Assets/icons/kodansha-news-placeholder.png';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';

interface KodanshaNewsWheelItemProps {
    date: string;
    src: string;
    title: string;
    description: string;
    url: string;
}


const KodanshaNewsWheelItem = ({ date, src, title, description, url }: KodanshaNewsWheelItemProps): ReactElement => {

    return (
        <Link to={url} className='news-wheel-item-container'>
            <span aria-label={'news date'} className='date'>{convertDate(date)}</span>
            <div aria-label={'news image'} className='poster-wrapper' style={{ cursor: 'pointer' }}>
                {/*<img onError={onImageError} draggable={false}*/}
                {/*     className='poster'*/}
                {/*     src={src ?? NewPlaceHolder}*/}
                {/*     alt={title} />*/}

                <SeriesPoster ratio={60} src={src}
                              preloadImage={false}
                              isGray={false}
                              s={{width: 366, aspectRatio: 0.8}}
                              m={{width: 400, aspectRatio: 0.8}}
                              l={{width: 313, aspectRatio: 0.8}}
                              xl={{width: 456, aspectRatio: 0.8}}
                              alt={title} />
            </div>
            {/*<span className='description'>{description ?? 'LICENSING ANNOUNCEMENTS'}</span>*/}
            <h3 aria-label={'news item ' + title} className='title'>{title}</h3>
        </Link>
    );
};

export default KodanshaNewsWheelItem;
